<!-- App.svelte -->

<script>
import { Navigate } from 'svelte-router-spa'

function getWindowHeight(){
    return 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
}

let a = getWindowHeight();

</script>

<style>
body, html {
  -moz-font-smoothing: antialiased;
  -ms-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
  -ms-overflow-style: scrollbar;
  -webkit-text-size-adjust: 100%;
  display: block;
  position: fixed;
  background: #f5f5f6;
  -webkit-tap-highlight-color: transparent; 
}

body * { touch-action: none;  } /* scroll disable */


.center {
    margin-left: auto;
    margin-right: auto;
}

.columns.is-vcentered {
  -webkit-box-align: center;
     -ms-flex-align: center;
        align-items: center;
}

</style>

<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

<body style="height: {a}px;">

<div class="container has-text-centered" style="height: 100%">
<div class="columns is-mobile is-vcentered" style="height: 100%">
<div class="column">

    <figure class="image">
    <img class="center" src="https://storage.googleapis.com/covelab-mmti/intro/home_scott.png" style="height: {a/2}px; width: auto;">
    </figure>

    <h1 class="title is-6">
    <p>MMTI 검사가 너무 정확해 "살짝 소름이 돋을 정도예요"</p>
    <p>라고 성격 유형 검사를 마친 한 멍뭉이는 말했습니다.</p>
    </h1>

    <h2 class="subtitle is-6"><br>쉽고 간단하면서도 정확한 성격 유형 검사를 통해
    <p>당신의 반려견은 누구이며,</p>
    <p>왜 그러한 특정 행동 성향을 보이는지 확인하십시오.</p>
    </h2>

    <div class="container">
    <Navigate to="/intro1">
    <figure class="image container is-128x128" style="width: 150px;"><img src="/next.png"></figure>
    <h1 class ="title is-6 is-overlay mt-4 mr-5 has-text-white"><p>다음</p></h1>
    </Navigate>
    </div>

    <figure class="image container is-32x32"><img src="/home_logo.png"></figure>

  

</div>
</div>
</div>
</body>
